import { tv } from 'tailwind-variants';

export const backToTopVariants = tv({
  slots: {
    container: ['back-to-top', 'text-center'],
    link: ['group', 'inline-block', 'hover:underline'],
    icon: [
      'fa-light',
      'fa-chevron-up',
      'block',
      'text-primary',
      'text-4xl',
      'leading-none',
      'transition-transform',
      'duration-300',
      'ease-out',
      'group-hover:-translate-y-[10px]',
      'group-hover:scale-x-90',
    ],
    text: [
      'text-xs font-black',
      'mt-[-8px]',
      'mb-[25px]',
      'leading-none',
      'uppercase',
      'text-light-black',
    ],
  },
});
